// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"310":"6c6a4356","586":"73eacd99","594":"bec74747"}[chunkId] + ".js";
};